export const SUGGEST_FROM_VALUES = {
  service: 'service',
  history: 'history',
  favorites: 'favorites',
  geolocation: 'geolocation'
}
